import {useMutation} from '@tanstack/react-query';
import {login} from "../queries/fetchAuth";
import { useNavigate } from 'react-router-dom';


export function useLogin(origin?: string) {
    const navigate = useNavigate();
    const {
        data,
        mutate: loginUser,
        isError,
        error,
        isSuccess,
        isPending
    } = useMutation({
        mutationKey: ['login'],
        mutationFn: login,
        retry: false
    });

    if (isSuccess) {
      if(origin) {
        navigate(`${origin}`);
      } else {
        navigate('/');
      } 
    }

    return {
        data,
        loginUser,
        isError,
        isLoading: isPending,
        error,
        isSuccess,
    }
}
